{
  "name": "obiserver-hosting-frontend",
  "version": "0.0.1-SNAPSHOT",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start-local-dev": "ng serve --configuration local-dev",
    "start-local-prod": "ng serve --configuration local-prod",
    "start-dev": "ng serve --configuration dev",
    "start-prod": "ng serve --configuration prod",
    "build": "ng build",
    "build-local-dev": "ng build --configuration local-dev",
    "build-local-prod": "ng build --configuration local-prod",
    "build-dev": "ng build --configuration dev",
    "build-prod": "ng build --configuration prod",
    "watch": "ng build --watch --configuration dev",
    "extract-i18n": "ng extract-i18n",
    "test": "ng test",
    "test-ci": "ng test --watch=false --browsers=ChromeHeadlessCI --code-coverage",
    "audit-prod": "npm audit --omit=dev --audit-level=high"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.2.1",
    "@angular/cdk": "^22.2.2",
    "@angular/common": "^22.2.1",
    "@angular/compiler": "^22.2.1",
    "@angular/core": "^22.2.1",
    "@angular/forms": "^22.2.1",
    "@angular/localize": "^22.2.1",
    "@angular/material": "^22.2.2",
    "@angular/platform-browser": "^22.2.1",
    "@angular/platform-browser-dynamic": "^22.2.1",
    "@angular/router": "^22.2.1",
    "ng-recaptcha": "^13.2.1",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1",
    "zone.js": "~0.16.3"
  },
  "devDependencies": {
    "@angular/build": "^22.2.2",
    "@angular/cli": "~22.2.2",
    "@angular/compiler-cli": "^22.2.1",
    "@types/jasmine": "~6.0.0",
    "baseline-browser-mapping": "^2.10.38",
    "eslint": "^10.11.0",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "~6.3.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.3.0",
    "karma-junit-reporter": "^2.0.1",
    "karma-spec-reporter": "^0.0.37",
    "typescript": "~6.0.3"
  }
}
